import { render } from "./ViewCount.vue?vue&type=template&id=0788d2c2&scoped=true"
import script from "./ViewCount.vue?vue&type=script&lang=js"
export * from "./ViewCount.vue?vue&type=script&lang=js"

import "./ViewCount.vue?vue&type=style&index=0&id=0788d2c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0788d2c2"]])

export default __exports__